"use strict";
/* globals module */
/**
 * @module baasicArticleACLRouteService
 * @description Baasic Article ACL Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
;
var contracts_1 = require("../../core/contracts");
var ArticleACLRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleACLRoute, _super);
    function ArticleACLRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'articles/{id}/acl/{?fields}';
        _this.updateRoute = 'articles/{id}/acl/{?fields}';
        _this.deleteByUserRoute = 'articles/{id}/acl/actions/{accessAction}/users/{user}/';
        _this.deleteByRoleRoute = 'articles/{id}/acl/actions/{accessAction}/roles/{role}/';
        return _this;
    }
    /**
     * Parses get article acl route; this URI template should be expanded with the Id of the article.
     * @method
     * @example articleACLRoute.get({id: '<article-id>'});
     **/
    ArticleACLRoute.prototype.get = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.getRoute, params);
    };
    /**
     * Parses update article acl route; this URI template should be expanded with the Id of the article.
     * @method
     * @example articleACLRoute.update({id: '<article-id>'});
     **/
    ArticleACLRoute.prototype.update = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.updateRoute, params);
    };
    /**
     * Parses deleteByUser article acl route which can be expanded with additional options. Supported items are:
     * - `id` - Id of the article.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified user and article resource.
     * - `user` - A value which uniquely identifies user for which ACL policy needs to be removed.
     * @method
     * @param articleId Article id which uniquely identifies article resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and article resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @param data An ACL policy object that needs to be updated in the system.
     * @example articleACLRoute.deleteByUser({
                        id: '<article-id>',
                        accessAction: '<access-action>',
                        user: '<username>'
                });
     **/
    ArticleACLRoute.prototype.deleteByUser = function (articleId, action, user, data) {
        var params = this.modelMapper.removeParams(data);
        params.articleId = articleId;
        params.user = user;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByUserRoute, params);
    };
    /**
     * Parses deleteByUser article acl route which can be expanded with additional options. Supported items are:
     * - `id` - Id of the article.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified role and article resource.
     * - `role` - A value which uniquely identifies role for which ACL policy needs to be removed.
     * @method
     * @param articleId Article id which uniquely identifies article resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and article resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role A value that uniquely identifies role for which ACL policy needs to be removed.
     * @param data An ACL policy object that needs to be updated in the system.
     * @example articleACLRoute.deleteByRole({
                    id: '<article-id>',
                    accessAction: '<access-action>',
                    role: '<role-name>'
                });
     **/
    ArticleACLRoute.prototype.deleteByRole = function (articleId, action, role, data) {
        var params = this.modelMapper.removeParams(data);
        params.articleId = articleId;
        params.role = role;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByRoleRoute, params);
    };
    ArticleACLRoute.prototype.updateParams = function (options) {
        var params = this.utility.extend({}, options);
        return params[this.modelMapper.modelPropertyName];
    };
    var _a;
    ArticleACLRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleACLRoute);
    return ArticleACLRoute;
}(common_1.BaseRoute));
exports.ArticleACLRoute = ArticleACLRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
